import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { AddIcon } from 'icons/materialIcons';

const TeamSubteamsEmptyState = ({ onCreateSubteam }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '60px 20px',
                textAlign: 'center'
            }}
        >
            <Typography
                variant="h6"
                sx={{
                    fontWeight: 600,
                    fontSize: '1.2rem',
                    color: '#4f4f4f',
                    marginBottom: 2
                }}
            >
                No Subteams
            </Typography>

            <Typography
                variant="body2"
                sx={{
                    color: '#757575',
                    fontSize: '0.875rem',
                    lineHeight: 1.6,
                    maxWidth: '600px',
                    marginBottom: 4
                }}
            >
                Subteams are a great way to organize and manage your team
                members by grouping them into their respective departments.
                You can also use Subteams in filters and apply bulk actions to them.
            </Typography>

            <Button
                variant="contained"
                startIcon={<AddIcon />}
                onClick={onCreateSubteam}
                sx={{
                    backgroundColor: '#000',
                    color: '#fff',
                    fontWeight: '500',
                    borderRadius: '0.5rem',
                    textTransform: 'none',
                    padding: '10px 24px',
                    '&:hover': {
                        backgroundColor: '#333',
                    }
                }}
            >
                Create a subteam
            </Button>
        </Box>
    );
};

export default TeamSubteamsEmptyState;

